'use client';

import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { isAuthenticatedAsMainUser } from '~/utils/user/user';

export function AboutMobileBanner() {
  const t = useTranslations('ABOUT');

  const { user, isAuthenticated, isAuthenticating, redirectToLogin } = useAuthenticatedContext();

  return (
    !isAuthenticatedAsMainUser(user, isAuthenticated) && !isAuthenticating
      ? (
          <div className="about__mobile-banner">
            <p className="vp-body-m">{t('STICKY_BANNER')}</p>
            <VpButton
              onClick={async () => await redirectToLogin()}
            >
              {t('ACTIONS.SIGN_UP')}
            </VpButton>
          </div>
        )
      : null
  );
}
